import React from 'react';

const ButtonRedInverted = ({type,onSubmit,disabled,text, onClick}) => {

  return (
    <button 
        type={type || 'submit'} 
        className='font-semibold text-center block bg-custom-charcoal text-red-600 border-red-800 rounded-md w-full min-h-[45px] hover:bg-red-600 hover:text-white transition-colors duration-200 px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed' 
        onClick={onClick || null}
        disabled={disabled ? true : false}
        onSubmit={onSubmit || null}
    >
        {text}
    </button>
  );
};

export default ButtonRedInverted;
